import React from 'react';
/* import { Container, Row, Col } from 'react-bootstrap'; */

import HeaderSection from '../components/HeaderSection';
import TopSimpleSection from '../components/TopSimpleSection';
import TopMenu from '../components/Navbar/Navbar';
/* import SimpleSection from '../components/SimpleSection'; */
//import Footer from '../components/Footer';
import Footer from '../components/Footer/Footer';
import Back2TopBtn from '../components/Back2TopBtn';
/* import WBkey from '../components/WBkey';
import Subscribe from '../components/Subscribe'; */

document.addEventListener('DOMContentLoaded', function () {
	window.addEventListener('scroll', function () {
		let navbar_height =
			document.getElementById('c-top-navbar').offsetHeight;
		if (window.scrollY > navbar_height + 50) {
			document.getElementById('c-top-navbar').classList.add('fixed-top');
			document.getElementById('c-nav-bar-fixer').style.height =
				navbar_height + 'px';
		} else {
			document
				.getElementById('c-top-navbar')
				.classList.remove('fixed-top');
			document.getElementById('c-nav-bar-fixer').style.height = 'auto';
		}
	});
});

export default function AboutLayout(props) {
	const {
		title,
		isad,
		subtitle,
		backgroundImage,
		children,
		search,
		button,
		collection,
		news,
		variant,
		apiService,
		setShowMetadata = () => {},
		showMetadata = false,
	} = props;

	return (
		<div className='c-main-wrapper'>
			<TopMenu background='white' />
			<TopSimpleSection
				title={title}
				backgroundImage={backgroundImage}
				search={search}
			/>
			{collection && (
				<HeaderSection
					title={title}
					subtitle={subtitle}
					isad={isad}
					collection
					variant={variant}
					agency={backgroundImage}
					setShowMetadata={setShowMetadata}
					showMetadata={showMetadata}
				/>
			)}
			{button && news && (
				<HeaderSection
					title={title}
					isad={isad}
					subtitle={subtitle}
					button
					news
					variant={variant}
					setShowMetadata={setShowMetadata}
					showMetadata={showMetadata}
				/>
			)}
			{!button && (
				<HeaderSection
					title={title}
					isad={isad}
					subtitle={subtitle}
					variant={variant}
					apiService={apiService}
					setShowMetadata={setShowMetadata}
					showMetadata={showMetadata}
				/>
			)}

			{children}
			<Back2TopBtn />
			<Footer />
		</div>
	);
}
